import AbstractRestApi from '@/api/RestApi/AbstractRestApi'

class CustomExportApiCategoryClient extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/custom-export-category'
    }
}

export default new CustomExportApiCategoryClient()
